/**
 * Shared content for the homepage. One source for agent names, roles and
 * portraits so every section shows the same people.
 */

export interface HomeAgent {
  id: string;
  name: string;
  role: string;
  /** Short job title shown on chips and board avatars. */
  job: string;
  portrait: string;
  summary: string;
  /** What the agent just did, shown as a live note on the portrait card. */
  note: string;
}

const portrait = (file: string) => `/avatars/ai-agents/${file}`;

export const HOME_AGENTS: HomeAgent[] = [
  {
    id: 'ashley',
    name: 'Ashley',
    role: 'Front desk',
    job: 'Answers calls',
    portrait: portrait('10-daytime-receptionist.jpg'),
    summary:
      'Picks up on the second ring, asks the right roofing questions and books the inspection on your calendar.',
    note: 'Inspection booked for Thursday, 2:00 PM',
  },
  {
    id: 'tyler',
    name: 'Tyler',
    role: 'Estimator',
    job: 'Quotes roofs',
    portrait: portrait('08-commercial-estimator.jpg'),
    summary:
      'Measures the roof from satellite imagery and sends good, better and best options before the homeowner calls anyone else.',
    note: '34 squares measured, 3 options sent',
  },
  {
    id: 'megan',
    name: 'Megan',
    role: 'Follow-up',
    job: 'Chases estimates',
    portrait: portrait('02-lead-response.jpg'),
    summary:
      'Texts every new lead within a minute and keeps following up on open estimates until the homeowner says yes or no.',
    note: 'Replied to a new lead in 38 seconds',
  },
  {
    id: 'marcus',
    name: 'Marcus',
    role: 'Storm response',
    job: 'Works storms',
    portrait: portrait('06-storm-surge.jpg'),
    summary:
      'When hail hits your area, he lines up the affected addresses and schedules your crews street by street.',
    note: '41 homes in the hail path, 12 scheduled',
  },
  {
    id: 'hunter',
    name: 'Hunter',
    role: 'Insurance claims',
    job: 'Handles claims',
    portrait: portrait('11-missed-call-recovery.jpg'),
    summary:
      'Collects photos, adjuster notes and paperwork so each claim moves forward without you chasing it.',
    note: 'Adjuster meeting confirmed for Monday',
  },
  {
    id: 'sofia',
    name: 'Sofia',
    role: 'Billing',
    job: 'Gets you paid',
    portrait: portrait('15-office-manager-copilot.jpg'),
    summary:
      'Sends invoices at each job milestone, reminds homeowners when payment is due and logs it in QuickBooks.',
    note: 'Milestone 2 invoice paid, $6,400',
  },
];

export const agentById = (id: string): HomeAgent =>
  HOME_AGENTS.find((agent) => agent.id === id) ?? HOME_AGENTS[0];
